import { useMemo, useContext } from "react";
import { FCX, PlatformContext } from "@datassential/platform-ui-lib";
import { useHomeRecentSearches } from "@apiHooks/useHomeRecentSearches";
import HomeSectionHeader from "@pages/Home/components/HomeSectionHeader";
import HomeSectionTitle from "@pages/Home/components/HomeSectionTitle";
import HomeSectionLoader from "@pages/Home/components/HomeSectionLoader";
import "./HomeRecentSearches.styles.scss";

const RECENT_SEARCHES_LIMIT = 20;

const HomeRecentSearches: FCX = () => {
    const { isLoading, data } = useHomeRecentSearches();
    const { globalSearch } = useContext(PlatformContext);

    const slicedSearchItems = useMemo(() => {
        return data.slice(0, RECENT_SEARCHES_LIMIT);
    }, [data]);

    const handleQueryClick = (query: string | null) => {
        if (!query) return;

        globalSearch.setQuery(query);
        globalSearch.setIsOpened(true);
    };

    return (
        <div className="HomeRecentSearches">
            <div className="Home__wrapper">
                <HomeSectionHeader>
                    <HomeSectionTitle>Recent Searches</HomeSectionTitle>
                </HomeSectionHeader>
                {isLoading && (
                    <HomeSectionLoader/>
                )}
                {!isLoading && (
                    <div className="Home__sub-wrapper pad-bottom">
                        <div className="HomeRecentSearches__container">
                            {slicedSearchItems.map((item, index) => (
                                <span
                                    key={item.id || index}
                                    className={`HomeRecentSearches__query-tag appears-top del-${index}`}
                                    onClick={() => handleQueryClick(item.query)}
                                >
                                {item.query}
                            </span>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default HomeRecentSearches;